function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.02998 2.44238V1.69375C5.02998 1.50045 4.87328 1.34375 4.67998 1.34375H4.24453C4.05123 1.34375 3.89453 1.50045 3.89453 1.69375V18.3687C3.89453 18.562 4.05123 18.7188 4.24453 18.7188H4.67998C4.87328 18.7188 5.02998 18.562 5.02998 18.3687V11.8387H16.6445C16.9386 11.8387 17.1016 11.4981 16.9171 11.2691L13.3703 6.86689L16.8845 3.02874C17.0901 2.8042 16.9308 2.44238 16.6264 2.44238H5.02998ZM5.02998 10.7032V3.57783H14.8419L12.0769 6.5976C11.9601 6.72515 11.954 6.91887 12.0625 7.05354L15.003 10.7032H5.02998Z",
  fill: "#00C4B5",
  stroke: "#00C4B5",
  strokeWidth: 0.5
});

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.a49915d1.svg";
export { ForwardRef as ReactComponent };